import { useQuery } from '@tanstack/react-query';
import { type ReactNode } from 'react';
import { ContactCard, FormSection, LangSwitch, OptionRow, ThemeToggle, pickText } from '@aps/ui';
import { useNavigation } from '../app/navigation.js';
import { useRegion } from '../app/region.js';
import { useSettings } from '../app/settings.js';
import { canOrder } from '../app/session.js';
import { api } from '../lib/api.js';
import { openTelegramLink } from '../lib/telegram.js';
import { useContact } from '../lib/use-contact.js';

export function ProfileScreen(): ReactNode {
  const { t, locale, setLocale, theme, setTheme } = useSettings();
  const { push } = useNavigation();
  const { regionId, setRegionId } = useRegion();
  const contact = useContact();

  const regions = useQuery({ queryKey: ['regions'], queryFn: api.regions, staleTime: 600_000 });
  const garage = useQuery({
    queryKey: ['garage'],
    queryFn: api.garage,
    retry: false,
    enabled: canOrder(),
  });

  const active = (garage.data ?? []).find((vehicle) => vehicle.isActive);

  return (
    <div className="aps-screen">
      <h1 className="aps-screen__title">{t('profile.title')}</h1>

      <FormSection title={t('profile.garage')}>
        <OptionRow
          label={
            active === undefined
              ? t('garage.empty')
              : `${active.makeName} ${active.modelName} ${String(active.year)}`
          }
          {...(active === undefined ? { hint: t('garage.emptyHint') } : {})}
          onSelect={() => {
            push({ name: 'garage' });
          }}
        />
      </FormSection>

      <FormSection title={t('checkout.region')}>
        <select
          className="aps-search__input"
          aria-label={t('checkout.region')}
          value={regionId ?? ''}
          onChange={(event) => {
            setRegionId(event.target.value === '' ? null : event.target.value);
          }}
        >
          <option value="">{t('checkout.region')}</option>
          {(regions.data ?? []).map((region) => (
            <option key={region.id} value={region.id}>
              {pickText(region.nameUz, region.nameRu, locale)}
            </option>
          ))}
        </select>
      </FormSection>

      <FormSection title={t('profile.language')}>
        <LangSwitch value={locale} onChange={setLocale} />
      </FormSection>

      <FormSection title={t('profile.theme')}>
        <ThemeToggle
          value={theme}
          onChange={setTheme}
          labels={{
            dark: t('profile.themeDark'),
            light: t('profile.themeLight'),
            race: t('profile.themeRace'),
            group: t('profile.theme'),
          }}
        />
      </FormSection>

      {/* Doimiy joy: mijoz so'ramasdan ham topadi. Tartib: garaj, hudud, til, mavzu, yordam. */}
      {contact.phone === '' && contact.telegram === '' ? null : (
        <FormSection title={t('help.section')}>
          <ContactCard
            title={t('help.title')}
            description={t('help.body')}
            hours={contact.hours}
            phone={contact.phone}
            telegram={contact.telegram}
            writeLabel={t('help.write')}
            embedded
            onOpenTelegram={openTelegramLink}
          />
        </FormSection>
      )}
    </div>
  );
}
